import RootActionTypes from "./root.types"

export const logout = () => ({
    type: RootActionTypes.LOGOUT,
    payload: undefined,
})